import React, { useState, useEffect } from "react"
import Slider from "react-slick"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"

import CarouselItem from "./CarouselItem/CarouselItem"

// import i18n from "../../translation/i18next"
// import { withTranslation } from "react-i18next"

import "./footerCarousel.scss"
import "../Carousel/slick.scss"

function NextArrow(props) {
  const { className, style, onClick } = props

  return (
    <NavigateNextIcon
      className={className}
      style={{
        ...style,
        border: "2px solid #ffffff",
        color: "#ffffff",
        borderRadius: 100,
        width: 40,
        height: 40,
        padding: 7,
        cursor: "pointer",
      }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props

  return (
    <NavigateBeforeIcon
      className={className}
      style={{
        ...style,
        border: "2px solid #ffffff",
        color: "#ffffff",
        borderRadius: 100,
        width: 40,
        height: 40,
        padding: 7,
        cursor: "pointer",
        zIndex: 1,
      }}
      onClick={onClick}
    />
  )
}

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height,
    }
  } else {
    return {
      width: 0,
      height: 0,
    }
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}

const Carousel = (props) => {
  // componentDidMount() {
  //   i18n.addResourceBundle(
  //     "en",
  //     "translation",
  //     this.props.carousel.en,
  //     true,
  //     true
  //   )
  //   i18n.addResourceBundle(
  //     "hu",
  //     "translation",
  //     this.props.carousel.hu,
  //     true,
  //     true
  //   )
  // }

  const { carousel, items_videos } = props
  // const { height, width } = useWindowDimensions()

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    draggable: true,
    lazyload: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: props.slidesToShow,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 12000,
          speed: 500,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px",
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
          autoplay: false,
          speed: 500,
        },
      },
    ],
  }

  return (
    <div className="footerCarousel-wrapper">
      {/* {width > 1024 && width !== 0 ? ( */}
      <Slider {...settings}>
        {carousel.map((element, index) => {
          return items_videos.data.map((item_video) => {
            if (
              item_video.description && item_video.description.includes(
                element.value.text_video_description
              )
            ) {
              return (
                <CarouselItem
                  image={
                    element.value.asset_video_thumbnail
                      ? `${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${element.value.asset_video_thumbnail.path}`
                      : ""
                  }
                  video={item_video.assets.hls}
                  video_iframe={item_video.assets.iframe}
                  url={element.value.text_button_url}
                  description={element.value.carousel_description}
                  key={index}
                />
              )
            }
          })
        })}
      </Slider>
      {/* ) : null} */}
    </div>
  )
}

export default /* withTranslation()( */ Carousel /* ) */
